import axios from 'axios';

const axiosInstance: any = axios.create({
  baseURL: process.env.REACT_APP_API_SERVER_URL,
  headers: {
    Accept: 'application/json',
    'Content-type': 'multipart/form-data',
  },
});

axiosInstance.interceptors.request.use(function (config: any) {
  return config;
});

axiosInstance.interceptors.response.use(
  (res: any) => {
    if (res.data.code === 401) {
      window.localStorage.setItem("auth_data", "");
      window.localStorage.setItem("auth_token", "");
      window.location.href = "/login";
    }
    return res.data;
  },
  (err: any) => {
    // check status, implement logic when api error
    // const error = err.response;
    return null; //Promise.reject(error);
  }
);

export default axiosInstance;
